import {UserRole} from "./UserRole";

/**
 * Role model.
 */
export default class Role {
	/**
	 * Get all roles possible to assign to created user.
	 * @returns {Role[]}
	 */
	static getRoles(): Role[] {
		return [
			Role.createRole(UserRole.Agent),
			Role.createRole(UserRole.ThirdPartyEngineer),
			Role.createRole(UserRole.SalesEngineer),
			Role.createRole(UserRole.Admin),
			Role.createRole(UserRole.BusinessDevelopmentPartner),
			Role.createRole(UserRole.PartnerTechnician)
		];
	}

	static createRole(role: string): Role {
		switch (role) {
			case UserRole.Admin:
				return new Role("ADMIN", UserRole.Admin, "Admin");
			case UserRole.SalesEngineer:
				return new Role("SALES_ENGINEER", UserRole.SalesEngineer, "Sales Engineer");
			case UserRole.ThirdPartyEngineer:
				return new Role("THIRD_PARTY_INSTALLER_ENGINEER", UserRole.ThirdPartyEngineer, "3rd Party Engineer");
			case UserRole.Agent:
				return new Role("AGENT", UserRole.Agent, "Agent");
			case UserRole.BusinessDevelopmentPartner:
				return new Role("BUSINESS_DEVELOPMENT_PARTNER", UserRole.BusinessDevelopmentPartner,
					"Business Development Partner");
			case UserRole.PartnerTechnician:
				return new Role("PARTNER_TECHNICIAN", UserRole.PartnerTechnician, "Partner Technician");
		}
	}

	constructor(public readonly id: string, public readonly value: string, public readonly label: string) {}
}
